// Column Line Chart Parameters
// Store Growth
const storeGrowthParameters = {
  parameters: {
    store_filters: {
      store_type_id: [1]
    },
    store_dimensions: ['retail_name', 'retail_store_name', 'store_id'],
    product_dimensions: [],
    date_dimensions: [],
    metrics: {
      normal: ['quantity_sold_1', 'quantity_sold_2', 'real_sales_amount_1', 'real_sales_amount_2',
        'real_sales_cost_1', 'real_sales_cost_2', 'stock_quantity'],
      var: ['quantity_sold', 'real_sales_amount', 'real_sales_cost']
    },
    fact: {
      type: 'table',
      name: ''
    },
    sort: {
      field: '',
      dir: 'DESC'
    },
    limit: 10,
    offset: 0
  }
}
// Pie Donut Cards
const pie1 = {
  dimension: 'store_type',
  store_type_id: [1, 3],
  limit: 0
}

const pie2 = {
  dimension: 'promoter_present',
  store_type_id: [1],
  limit: 0
}

const pie3 = {
  dimension: 'comuna',
  store_type_id: [1],
  limit: 10
}

const pie4 = {
  dimension: 'vendor_product_code',
  limit: 50,
  store_type_id: []
}
// Common parameter

const gridParameters = {
  parameters: {
    store_dimensions: ['retail_name'],
    product_dimensions: [],
    date_dimensions: [],
    metrics: {
      normal: ['quantity_sold_1', 'quantity_sold_2', 'real_sales_amount_1', 'real_sales_amount_2',
        'real_sales_cost_1', 'real_sales_cost_2', 'stock_quantity'],
      var: ['quantity_sold', 'real_sales_amount', 'real_sales_cost']
    },
    fact: {
      type: 'table',
      name: ''
    },
    sort: {
      field: '',
      dir: 'DESC'
    },
    limit: 0,
    offset: 0
  }
}

const storeGrowthListDetail = {
  'parameters': {
    'store_filters': {
      'store_type_id': [1]
    },
    'product_dimensions': [],
    'store_dimensions': ['retail_store_name', 'store_id', 'retail_name', 'gmap_coordinate'],
    'date_dimensions': [],
    'metrics': {
      'normal': [], 'var': []
    },
    'fact': {
      'type': 'table', 'name': ''
    },
    'sort': {
      'field': '', 'dir': 'Desc'
    },
    'having_filters': [],
    'limit': 100,
    'offset': 0
  }
}

const chartParameters = {
  parameters: {
    // store_dimensions: ['retail_name', 'retail_id'],
    // product_dimensions: [],
    date_dimensions: [],
    metrics: {
      normal: ['quantity_sold_1', 'quantity_sold_2', 'stock_quantity'],
      var: ['quantity_sold']
    },
    fact: {
      type: 'table',
      name: 'dw_ytd_comparative'
    },
    sort: {
      field: 'quantity_sold_1',
      dir: 'DESC'
    },
    limit: 0,
    offset: 0
  }
}

const storeGrowthMap = {
  'parameters': {
    'store_filters': {
      'store_id': []
    },
    'store_dimensions': ['gmap_coordinate', 'retail_name', 'retail_store_name', 'store_id'],
    'metrics': {
      'normal': ['real_sales_amount_2', 'real_sales_amount_1'],
      'var': ['real_sales_amount']
    },
    'fact': {
      'type': 'table',
      'name': 'dw_ytd_comparative'
    }
  }
}

const metricOptions = {
  UNITS:
    {
      normal: ['quantity_sold_1', 'quantity_sold_2', 'real_sales_cost_1', 'real_sales_cost_2', 'stock_quantity'],
      var: ['quantity_sold', 'real_sales_cost'],
      varResponse: ['quantity_sold_var']
    },
  PESOS:
    {
      normal: ['real_sales_amount_1', 'real_sales_amount_2', 'real_sales_cost_1', 'real_sales_cost_2', 'real_stock_pvp_amount'],
      var: ['real_sales_amount', 'real_sales_cost'],
      varResponse: ['real_sales_amount_var']
    },
  MERGED:
    {
      normal: ['real_sales_amount_1', 'real_sales_amount_2', 'quantity_sold_1', 'quantity_sold_2', 'real_sales_cost_1',
        'real_sales_cost_2', 'stock_quantity', 'real_stock_pvp_amount'],
      var: ['quantity_sold', 'real_sales_amount', 'real_sales_cost'],
      varResponse: ['real_sales_amount_var', 'quantity_sold_var', 'real_sales_cost']
    }
}

const chartMetricOptions = {
  UNITS: ['quantity_sold_1', 'quantity_sold_2', 'stock_quantity'],
  PESOS: ['real_sales_amount_1', 'real_sales_amount_2', 'real_stock_pvp_amount']

}

const chartMetricSeriesName = {
  UNITS: ['SO Actual', 'SO Anterior', 'Stock'],
  PESOS: ['SO $ Actual', 'SO $ Anterior', 'Stock $ PVP']

}

const gridColDefsNames = {
  UNITS:
    {
      salesGroupName: 'Sellout Unidades',
      stockGroupName: 'Stock Unidades'
    },
  PESOS:
    {
      salesGroupName: 'Sellout $',
      stockGroupName: 'Stock PVP $'
    }
}

const filterOptions = {
  UNITS: ['sum(quantity_sold_2) > sum(quantity_sold_1)', 'sum(quantity_sold_1) <> 0'],
  PESOS: ['sum(real_sales_amount_2) > sum(real_sales_amount_1)', 'sum(real_sales_amount_1) <> 0']
}

export { storeGrowthParameters, pie1, pie2, pie3, pie4, gridParameters, metricOptions, storeGrowthMap,
  gridColDefsNames, chartParameters, chartMetricOptions, chartMetricSeriesName, filterOptions, storeGrowthListDetail }



// WEBPACK FOOTER //
// ./src/expertoRetail/atoms/AccumulatedSales/Common/baseParameters.js